module.exports = __webpack_public_path__ + "static/media/greeting.9da1e05a.svg";